import type { VestigoUserData, VstDebugRecord } from './global';

/**
 * Wrappers finos sobre `window.vestigo`. Antes do `s.js` carregar, o stub
 * enfileira as chamadas; depois, elas vão direto para a API real. Não
 * reimplementam nada — só dão tipagem e um ponto único de chamada.
 */

export function track(
  name: string,
  params?: Record<string, unknown>,
  userData?: VestigoUserData,
): void {
  window.vestigo.track(name, params, userData);
}

export function identify(userData: VestigoUserData): void {
  window.vestigo.identify(userData);
}

export function consent(granted: boolean): void {
  window.vestigo.consent(granted);
}

/** Só existe depois que o `s.js` substitui `window.vestigo` pela API real. */
export function getVisitorId(): string | null {
  const v = window.vestigo;
  return v && typeof v.getVisitorId === 'function' ? v.getVisitorId() : null;
}

/** Resolve quando a API real estiver pronta (getVisitorId disponível). */
export function onReady(cb: (visitorId: string) => void): () => void {
  let done = false;
  const tick = () => {
    if (done) return;
    const id = getVisitorId();
    if (id) {
      done = true;
      cb(id);
    }
  };
  tick();
  const timer = window.setInterval(tick, 200);
  const stop = window.setTimeout(() => window.clearInterval(timer), 15000);
  return () => {
    window.clearInterval(timer);
    window.clearTimeout(stop);
  };
}

/** Assina o feed do interceptor de rede (todos os eventos enviados a /t/e). */
export function subscribe(cb: (rec: VstDebugRecord) => void): () => void {
  window.__vst.subs.push(cb);
  return () => {
    const i = window.__vst.subs.indexOf(cb);
    if (i >= 0) window.__vst.subs.splice(i, 1);
  };
}

export function history(): VstDebugRecord[] {
  return window.__vst?.events ?? [];
}
